export default __webpack_public_path__ + "static/media/r3.5479c355.png";